/**
 시스템 > TAMS 로그 > Ticket Browser
 @since: 2021-05-24
 @author: wj_tams_dev02
 **/
import {i18n} from '~/plugins/i18n'
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  txtTicketBrowserUrl: '/api/lr/ticket/browser',
  txtTicketHistoryUrl: '/api/lr/ticket/browser/history',
  txtTicketManageUrl: '/api/lr/ticket/browser/mgmt',
  txtExceptionListUrl: '/api/op/as/exceptions',
  txtExceptionListCommitUrl: '/api/op/as-exceptions',
  // 선택한 row 데이터
  rowSelectItems: {},
  getTicketBrowserData: [],
  getTicketHistoryData: [],
  getTicketManageData: {},
  popupData: {}, // POPUP data
  ownerOption: [
    {
      label: 'ALL',
      value: 0
    }
  ],
  getManageHistoryData: [],
  eventLevelTypes: [],
  terminateProcessList: [],
  // [[ Ticket History Start ]]
  search: {
    id: '',
    page_num: 1,
    isFirst: true
  },
  searchData: {
    log_type: '',
    stime: '',
    etime: '',
    total_rows: 10000,
    page_rows: 1000,
    order_by: 'desc',
    filters: []
  },
  searchState: {
    status: 'INIT', // 초기 단계: INIT, 추이 검색 중: SEARCHING_TREND_LOG, 로그 검색 중: SEARCHING_LOG, 검색 중지 요청 중: REQUEST_STOP, 로그 검색이 중지 됨: STOPPED, 로그 검색 완료: DONE
    progress: 0,
    searched_cnt: 0
  },
  // 필터 key 변경
  filterKey: {
    // [장비 이름, 티켓 이름, 발생 시간, 발생 기준, 티켓 상태, 발생 등급, 접수자, 종료자]
    ticket_browser_device_uname: 'ticket_browser_device_uname', // 장비 이름
    ticket_browser_ticket_uname: 'ticket_browser_ticket_uname', // 티켓 이름
    // ticket_browser_occur_time: 'ticket_browser_occur_time', // 발생 시간
    // ticket_browser_occur_term: 'ticket_browser_occur_term', // 발생 기준
    ticket_browser_ticket_status: 'ticket_browser_ticket_status', // 티켓 상태
    ticket_browser_occur_grade: 'ticket_browser_occur_grade' // 발생 등급
    // ticket_browser_receptor_login_id: 'ticket_browser_receptor_login_id' // 접수자
    // ticket_browser_terminator_login_id: 'ticket_browser_terminator_login_id' // 종료자
  },
  dataList: []
  // [[ Ticket History End ]]
})

export const mutations = {
  clearStore: (state) => {
    state.rowSelectItems = {}
    state.getTicketBrowserData = []
    state.getTicketHistoryData = []
    state.popupData = {}
    state.ownerOption = [{label: 'ALL', value: 0}]
    state.eventLevelTypes = []
    state.getManageHistoryData = []
    state.getTicketManageData = []
    state.terminateProcessList = []
    // Ticket History
    state.search = {}
    state.searchData = {}
    state.searchState = {}
    state.dataList = []
  },
  setRowSelectItems: (state, data) => { // TICKET EVENT BROWSER 테이블 선택 정보
    state.rowSelectItems = _.cloneDeep(data)
  },
  getTicketBrowserDataAction: (state, data) => {
    _.forEach(data, (item) => {
      item.occurTerm = item.ticket_browser_occur_type === 2 ? i18n.t('cmn.realtime') : i18n.t('lr.ticketBrowser_table_event_term_text', {term: item.ticket_browser_occur_term, cnt: item.ticket_browser_occur_cnt})
    })
    state.getTicketBrowserData = _.cloneDeep(data)
  },
  getTicketBrowserPopupData: (state, data) => { // TICKET EVENT BROWSER 상세 조회
    state.ownerOption = [{label: 'ALL', value: 0}]
    _.forEach(data.ticket_mgmt_owner_list, (item) => {
      state.ownerOption.push({label: item.ticket_user_login_id, value: item.ticket_user_id})
    })
    state.popupData = _.cloneDeep(_.omit(data, ['userInfo', 'ticket_mgmt_owner_list']))
    if (state.popupData.ticket_browser_receptor_login_id === null) {
      state.popupData.ticket_browser_receptor_id = _.cloneDeep(data.userInfo.adm_id)
      state.popupData.ticket_browser_receptor_login_id = _.cloneDeep(data.userInfo.login_id)
    }
    state.getTicketManageData = _.cloneDeep(data.ticket_mgmt_history_list)
  },
  getTicketHistoryPopupData: (state, data) => {
    state.ownerOption = [{label: 'ALL', value: 0}]
    _.forEach(data.ticket_mgmt_owner_list, (item) => {
      state.ownerOption.push({label: item.ticket_user_name, value: item.ticket_user_id})
    })
    state.popupData = _.cloneDeep(_.omit(data, ['userInfo', 'ticket_mgmt_owner_list']))
    state.getTicketManageData = _.cloneDeep(data.ticket_mgmt_history_list)
  },
  getEventLevelType: (state, data) => {
    if (data.length > 0) {
      const typeColor = {}
      _.forEach(data, (item) => {
        typeColor[`${item.event_level_type}`] = item.event_level_color
      })
      state.eventLevelTypes = typeColor
    }
  },
  getTicketManagePopupData: (state, data) => {
    state.getManageHistoryData = _.cloneDeep(data)
  },
  getSearchState (state, payload) { // page set
    state.searchState.searched_cnt = payload[0].cnt
    state.search.page_num = 1
  },
  getTicketHistoryDataAction: (state, data) => {
    _.forEach(data, (item) => {
      item.occurTerm = item.ticket_browser_occur_type === 2 ? i18n.t('cmn.realtime') : i18n.t('lr.ticketBrowser_table_event_term_text', {term: item.ticket_browser_occur_term, cnt: item.ticket_browser_occur_cnt})
    })
    state.dataList = _.cloneDeep(data)
  },
  getTerminateProcessList: (state, data) => {
    _.forEach(data, (item) => {
      item.ticket_terminate = 0
      item.occurTerm = item.ticket_browser_occur_type === 2 ? i18n.t('cmn.realtime') : i18n.t('lr.ticketBrowser_table_event_term_text', {term: item.ticket_browser_occur_term, cnt: item.ticket_browser_occur_cnt})
    })
    state.terminateProcessList = _.cloneDeep(data)
  },
  terminateHeaderMutation: (state, data) => {
    state.terminateProcessList = _.map(state.terminateProcessList, (item) => {
      item.ticket_terminate = data
      return item
    })
  }
}

export const actions = {
  // Ticket Browser 목록 조회
  async getTicketBrowserDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtTicketBrowserUrl, {}, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getTicketBrowserDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 이벤트 레벨별 색상
  async getEventLevelType ({commit}) {
    try {
      const data = await this.$axios.$get('/api/sm/event-level', {}, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getEventLevelType', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Ticket Browser Popup Open 시 접수자 등록
  async editTicketBrowserForOpen ({commit, state, rootState}) {
    try {
      const payload = {}
      payload.ticket_browser_id = state.rowSelectItems[0].ticket_browser_id
      payload.ticket_browser_receptor_id = rootState.common.common.uiData.user.adm_id
      const data = await this.$axios.$put(state.txtTicketBrowserUrl, payload, {loading: false, successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Ticket Browser Popup Close 시 접수자 및 담당자 등록
  async editTicketBrowserForClose ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(state.txtTicketBrowserUrl, payload, {loading: false, successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // TICKET Event Browser 팝업 창(티켓 관리) 데이터 조회(상단 테이블)
  async getTicketBrowserPopupData ({commit, state, rootState}) {
    try {
      const data = await this.$axios.$get(`${state.txtTicketManageUrl}/${state.rowSelectItems[0].ticket_browser_id}`, {}, {loading: false, successAlert: false})
      if (data.code === 'ok') { // 결과가 OK 인 경우
        data.result.userInfo = rootState.common.common.uiData.user
      }
      return resultFactory(commit, {length: null, data: data, action: 'getTicketBrowserPopupData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // TICKET Event History 팝업 창(티켓 관리) 데이터 조회(하단 테이블)
  async getTicketHistoryPopupData ({commit, state}, payload) {
    try {
      const data = await this.$axios.$get(`${state.txtTicketManageUrl}/${payload}`, {}, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getTicketHistoryPopupData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 티켓 관리 단계별 팝업 창 데이터 설정
  async setTicketManageData ({commit, state, rootState}, payload) {
    payload.append('ticket_mgmt_worker_id', rootState.common.common.uiData.user.adm_id)
    try {
      const data = await this.$axios.$put(`${state.txtTicketManageUrl}`, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 티켓 관리 팝업 창 > 단계별 팝업 창 데이터 조회
  async getTicketManagePopupData ({commit, state}, payload) {
    try {
      const data = await this.$axios.$get(`${state.txtTicketManageUrl}/detail/${payload}`, {}, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getTicketManagePopupData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Ticket Browser History 목록 COUNT 조회
  async getSearchState ({commit, state}) { // 조건에 맞게 검색 Request 를 날리고, 그 결과로 cnt 를 가져옴.
    try {
      const req = {ticket_browser_start_dt: state.searchData.stime, ticket_browser_end_dt: state.searchData.etime}
      state.searchData.filters.forEach(item => {
        const filterWord = (item.key === 'ticket_device_id') ? 'ticket_browser_device_uname' : item.key
        const key = state.filterKey[filterWord]
        const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
        if (typeof key !== 'undefined') {
          const listKey = `${key}_list`
          if (key === 'audit_log_result_type') {
            req[key] = parseInt(codesD[0])
          } else {
            req[listKey] = codesD.map(x => {
              return isNaN(x) ? x : parseInt(x)
            })
          }

          if (item.key !== 'admin_login_ip') {
            req[`${key}_not_yn`] = (item.is_not) ? 1 : 0
          }
        }
      })
      const data = await this.$axios.$post(`${state.txtTicketHistoryUrl}/stat`, req, {loading: false, successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getSearchState', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Ticket Browser History 목록 조회
  async getSearchResult ({commit, state}) {
    const req = {
      order_by: state.searchData.order_by,
      page_cnt: state.searchData.page_rows,
      page_pos: (state.search.page_num - 1)
    }
    req.ticket_browser_start_dt = state.searchData.stime
    req.ticket_browser_end_dt = state.searchData.etime

    state.searchData.filters.forEach(item => {
      const filterWord = (item.key === 'ticket_device_id') ? 'ticket_browser_device_uname' : item.key
      const key = state.filterKey[filterWord]
      const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
      if (typeof key !== 'undefined') {
        const listKey = `${key}_list`
        if (key === 'audit_log_result_type') {
          req[key] = parseInt(codesD[0])
        } else {
          req[listKey] = codesD.map(x => {
            return isNaN(x) ? x : parseInt(x)
          })
        }

        if (item.key !== 'admin_login_ip') {
          req[`${key}_not_yn`] = (item.is_not) ? 1 : 0
        }
      }
    })

    try {
      const data = await this.$axios.$post(state.txtTicketHistoryUrl, req, {loading: false, successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getTicketHistoryDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 임의 종결 목록 조회
  async getTerminateProcessList ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtTicketBrowserUrl}/pub`, {}, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getTerminateProcessList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 임의 종결
  async setTerminateProcessList ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.txtTicketManageUrl}/terminate`, payload, {loading: false, successAlert: false})
      return resultFactory(commit, {length: payload.ticket_browser_id_list.length, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // TICKET Browser 적용/취소
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true, loading: false}
      } else if (type === 'cancel') {
        msg = {successAlert: false, loading: false}
      }
      const data = await this.$axios.$put(`${state.txtTicketManageUrl}/${type}`, null, msg)
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
